export const CUT_OFF_TIME_WHITELISTED_URLS = [
  "/luggage",
  "/dashboard",
  "/precruise",
];
